import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { Typography } from 'cprime-foundational-components';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { generateTestId } from 'utils/general';

const Link = ({ id, label, onClick, variant = 'h3' }) => {
  return (
    <Stack
      data-testid={generateTestId('VehicleRecord', 'VehicleAssignmentHistoryLink', id)}
      direction="row"
      alignItems="center"
      spacing="0.25rem"
      display="inline-flex"
      onClick={onClick}
    >
      <Typography variant={variant} component="span" color="info.main" sx={{ cursor: 'pointer' }}>
        {label}
      </Typography>
      <InsertLinkIcon
        sx={{
          width: '1rem',
          height: '1rem',
          color: 'info.main',
        }}
      />
    </Stack>
  );
};

Link.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string,
};

export default Link;
